import * as React from 'react';
import { LogbogAfsnit } from '../../models/LogbogAfsnit';
import { LogbogDialog } from '../../models/LogbogDialog';
import LogbogDialogComponent from './LogbogDialogComponent';
import LogbogIndlaegEditComponent from '../Logbog/LogbogIndlaegEditComponent';
import { getLoggedInBruger } from '../../infrastructure/Security';

export interface LogbogAfsnitContentProps {
    logbogAfsnit: LogbogAfsnit;
    dialog?: LogbogDialog;
    createIndlaeg: any;
    updateIndlaeg: any;
    logbogAfsnitId: string;
}

export default class LogbogAfsnitContent extends React.Component<LogbogAfsnitContentProps,
    any> {

    constructor(props: LogbogAfsnitContentProps) {
        super(props);
    }

    getLogbogEditComponent() {
        return (
            <LogbogIndlaegEditComponent 
                logbogAfsnitId={this.props.logbogAfsnit.id}
                createIndlaeg={this.props.createIndlaeg} 
                bruger={getLoggedInBruger()} 
            />              
        );
    }

    render() {

        return (
            <div className='logbog-afsnit-content'>
                {this.getLogbogEditComponent()}                
                <LogbogDialogComponent dialog={this.props.dialog} updateIndlaeg={this.props.updateIndlaeg} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/LogbogAfsnitContent.tsx